"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[499],{

/***/ 6369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wI": function() { return /* binding */ AppProvider; },
  "mr": function() { return /* binding */ useAppState; }
});

// UNUSED EXPORTS: useAppDispatch

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/interfaces/context/appContextInterfaces.ts
var appContextInterfaces = __webpack_require__(4182);
;// CONCATENATED MODULE: ./src/reducers/companyReducer.ts

const companyReducer = (state, action)=>{
    switch(action.type){
        case appContextInterfaces/* CompanyActionTypes.updateCompany */.i.updateCompany:
            {
                const updatedState = {
                    ...state,
                    ...action.payload
                };
                return updatedState;
            }
        case appContextInterfaces/* CompanyActionTypes.resetCompany */.i.resetCompany:
            {
                return null;
            }
        default:
            {
                return state;
            }
    }
};

// EXTERNAL MODULE: ./src/reducers/userReducer.ts
var userReducer = __webpack_require__(8112);
;// CONCATENATED MODULE: ./src/utils/reducers.ts
// Stolen directly from https://github.com/the-road-to-learn-react/use-combined-reducers
// because the NPM installed version has a build error which prevents us using it.
const useCombinedReducers = (combinedReducers)=>{
    // Global State
    const state = Object.keys(combinedReducers).reduce((acc, key)=>({
            ...acc,
            [key]: combinedReducers[key][0]
        }), {});
    // Global Dispatch Function
    const dispatch = (action)=>Object.keys(combinedReducers).map((key)=>combinedReducers[key][1]).forEach((fn)=>fn(action));
    return [
        state,
        dispatch
    ];
};

;// CONCATENATED MODULE: ./src/hooks/AppContext.tsx





const defaultAppState = {
    user: {
        logged_in: false,
        view_bookings: false,
        company: null,
        location: null,
        cropped_name: "",
        email: "",
        favorite_posts: [],
        name: "",
        id: null,
        isInitialized: false
    },
    company: {}
};
const AppStateContext = /*#__PURE__*/ react.createContext(defaultAppState);
const AppDispatchContext = /*#__PURE__*/ react.createContext(undefined);
/**
 * App Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <AppProvider>
 *   <Component />
 * </AppProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useAppState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useAppDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ const AppProvider = (props)=>{
    const { company , cultures , children , employeeStories  } = props;
    const [state, dispatch] = useCombinedReducers({
        company: react.useReducer(companyReducer, company ? {
            ...company
        } : defaultAppState.company),
        user: react.useReducer(userReducer/* userReducer */.M, defaultAppState.user)
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStateContext.Provider, {
        value: {
            ...state,
            cultures,
            employeeStories
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const useAppState = ()=>{
    const context = react.useContext(AppStateContext);
    if (context === undefined) {
        throw new Error("useAppState must be used within the AppProvider");
    }
    return context;
};
const useAppDispatch = ()=>{
    const context = react.useContext(AppDispatchContext);
    if (context === undefined) {
        throw new Error("useAppDispatch must be used within the AppProvider");
    }
    return context;
};
AppProvider.displayName = "AppProvider";
useAppState.displayName = "useAppState";
useAppDispatch.displayName = "useAppDispatch";



/***/ }),

/***/ 4182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UserActionTypes; },
/* harmony export */   "i": function() { return /* binding */ CompanyActionTypes; }
/* harmony export */ });
var UserActionTypes;
(function(UserActionTypes) {
    UserActionTypes["updateUser"] = "update_user";
    UserActionTypes["resetUser"] = "reset_user";
})(UserActionTypes || (UserActionTypes = {}));
var CompanyActionTypes;
(function(CompanyActionTypes) {
    CompanyActionTypes["updateCompany"] = "update_company";
    CompanyActionTypes["resetCompany"] = "reset_company";
})(CompanyActionTypes || (CompanyActionTypes = {}));


/***/ }),

/***/ 8112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ userReducer; }
/* harmony export */ });
/* harmony import */ var interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4182);

const defaultState = {
    isInitialized: false,
    logged_in: false,
    view_bookings: false,
    company: null,
    location: null,
    cropped_name: "",
    email: "",
    favorite_posts: [],
    name: "",
    id: null
};
const userReducer = (state, action)=>{
    switch(action.type){
        case interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_0__/* .UserActionTypes.updateUser */ .F.updateUser:
            {
                const updatedState = {
                    ...state,
                    ...action.payload
                };
                return updatedState;
            }
        case interfaces_context_appContextInterfaces__WEBPACK_IMPORTED_MODULE_0__/* .UserActionTypes.resetUser */ .F.resetUser:
            {
                return defaultState;
            }
        default:
            {
                return state;
            }
    }
};


/***/ }),

/***/ 6366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zt": function() { return /* binding */ fetchArticles; },
  "SC": function() { return /* binding */ fetchCompanySuggestions; },
  "bG": function() { return /* binding */ fetchJobs; },
  "BT": function() { return /* binding */ fetchUser; },
  "V1": function() { return /* binding */ getJobRecommendations; }
});

// UNUSED EXPORTS: fetchApiCompanySuggestions, fetchApiUser, getCulturesList, getEmployeeStories, getSingleCompany

// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
// EXTERNAL MODULE: ./node_modules/next/config.js
var next_config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/node-cache/index.js
var node_cache = __webpack_require__(7915);
var node_cache_default = /*#__PURE__*/__webpack_require__.n(node_cache);
// EXTERNAL MODULE: ./src/utils/axiosClient.ts
var utils_axiosClient = __webpack_require__(6704);
;// CONCATENATED MODULE: ./src/mocks/mockSingleCompany.json
var mockSingleCompany_namespaceObject = {};
// EXTERNAL MODULE: ./src/utils/browser.ts
var utils_browser = __webpack_require__(7228);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
;// CONCATENATED MODULE: ./src/utils/api.ts









// Expire once a day, check every 5 minutes
const apiCache = new (node_cache_default())({
    stdTTL: 86400,
    checkperiod: 300
});
const getJobRecommendations = async ()=>{
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs  }  } = (0,next_config["default"])();
    const response = await utils_axiosClient/* axiosClient.get */.U.get(`${apiBase}/recommendations`, {
        timeout: apiRequestTimeoutMs
    }).catch((error)=>{
        const msg = `Error requesting recommendations at ${apiBase}/recommendations.`;
        const err = JSON.stringify((0,logging/* formatLog */.U)({
            error
        }));
        console.error(msg, err);
    }).then((res)=>res?.data);
    return response;
};
/**
 * Formatter for The Muse Jobs.
 * This is the default.
 */ const getFormattedQueryParams = (queryParams = null)=>({
        ...queryParams,
        ...queryParams.query && {
            query: queryParams.query.substring(0, constants/* jobSearchQueryMaxlength */.L8)
        }
    });
/**
 * Returns the Axios config for requesting Jobs from TheMuse.
 */ const getMuseJobsConfig = (queryParams, cookies)=>{
    const { serverRuntimeConfig: { jobsApiHost  }  } = (0,next_config["default"])();
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs  }  } = (0,next_config["default"])();
    const path = (0,utils_browser/* isBrowser */.jU)() ? `${apiBase}/jobs?limit=5` : `${jobsApiHost}/api/v2/search/jobs?limit=5`;
    const formattedQueryParams = getFormattedQueryParams(queryParams);
    const museConfig = {
        method: "GET",
        url: path,
        headers: (0,utils_browser/* isBrowser */.jU)() ? {} : {
            Cookie: cookies || ""
        },
        params: {
            ...formattedQueryParams,
            timeout: apiRequestTimeoutMs
        }
    };
    return museConfig;
};
/**
 * Request jobs directly from the backend API or proxied through the Next.js internal API.
 */ const fetchJobs = async (queryParams, cookies)=>{
    const axiosConfig = getMuseJobsConfig(queryParams, cookies);
    try {
        const response = await axios_default()(axiosConfig);
        return response.data;
    } catch (error) {
        const msg = `Company Renderer was unable to request job results from ${axiosConfig.url}`;
        const err = JSON.stringify((0,logging/* formatLog */.U)({
            error
        }));
        console.error(msg, err);
        throw new Error(msg);
    }
};
/**
 * Request articles directly from the backend API or proxied through the Next.js internal API.
 */ // eslint-disable-next-line max-len
const fetchArticles = async (queryParams, cookies)=>{
    const browser = (0,utils_browser/* isBrowser */.jU)();
    const { publicRuntimeConfig: { apiBase  } , serverRuntimeConfig: { articleApiHost  } ,  } = (0,next_config["default"])();
    const apiPathname = `companies/${queryParams.company_short_name}/filtered-articles`;
    const url = browser ? `${apiBase}/${apiPathname}` : `${articleApiHost}/api/v1/${apiPathname}`;
    const defaultParams = {
        company_short_name: "",
        orderBy: "dateUpdated+desc",
        page: "0",
        type: "articles,listicles"
    };
    const requestParams = new URLSearchParams({
        ...defaultParams,
        ...queryParams
    }).toString().replace(/%2B|%2C/g, decodeURIComponent);
    const axiosConfig = {
        method: "GET",
        url: `${url}?${requestParams}`,
        headers: browser ? {} : {
            "Content-Type": "application/json",
            Cookie: cookies || ""
        },
        timeout: 30000
    };
    try {
        const response = await axios_default()(axiosConfig).then((r)=>r?.data || r);
        return response;
    } catch (error) {
        const msg = `Company Renderer was unable to request article results from ${axiosConfig.url}`;
        const err = JSON.stringify((0,logging/* formatLog */.U)({
            error
        }));
        console.error(msg, err);
        throw new Error(msg);
    }
};
const getSingleCompany = async (queryParams)=>{
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs  } , serverRuntimeConfig: { companyApiHost , companyApiToken , mockApiResponses  }  } = getConfig();
    const { companyShortName  } = queryParams;
    const config = {
        timeout: apiRequestTimeoutMs,
        headers: {
            Authorization: `Bearer ${companyApiToken}`
        }
    };
    // If either query param length exceeds the maximum, throw a malformed request error
    if (companyShortName?.length > jobQueryCompanyShortnameMaxlength) {
        // eslint-disable-next-line max-len
        const msg = `Malformed Request: The companyShortName parameter exceeds maximum length of ${jobQueryCompanyShortnameMaxlength}.`;
        throw new Error(msg);
    }
    const path = isBrowser() ? `${apiBase}/company/${companyShortName}` : `${companyApiHost}/api/v1/companies/${companyShortName}`;
    // Fetch the company from the API.
    const response = mockApiResponses ? {
        data: mockSingleCompany
    } : await axiosClient.get(path, config).catch((error)=>{
        const msg = `Error requesting company at ${path}.`;
        const err = JSON.stringify(formatLog({
            error
        }));
        console.error(msg, err);
    });
    const apiCompanyRequest = response?.data;
    const company = compressedCompany(apiCompanyRequest);
    return company;
};
/**
 * Request the user.
 */ const fetchUser = async (axiosOptions)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , apiBase  }  } = (0,next_config["default"])();
    const config = {
        ...{
            timeout: apiRequestTimeoutMs,
            headers: {
                "Content-Type": "application/json"
            }
        },
        ...axiosOptions
    };
    const path = `${apiBase}/user`;
    try {
        const response = await axios_default()(path, config);
        return response.data;
    } catch (error) {
        const msg = `Company Renderer was unable to request the user from ${path}.`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
        return null;
    }
};
/**
 * Request user from the service API.
 */ const fetchApiUser = async (oskarId = "", sessionId = "", axiosOptions)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , museApiHost , museHost  }  } = getConfig();
    const config = {
        ...{
            timeout: apiRequestTimeoutMs,
            headers: {
                "Content-Type": "application/json",
                cookie: `oskar_id=${oskarId}; session_id=${sessionId}`,
                referer: museHost
            }
        },
        ...axiosOptions
    };
    const path = `${museApiHost}/api/user`;
    try {
        const response = await axios(path, config);
        return response;
    } catch (error) {
        const msg = `Company Renderer was unable to request the user from ${path}.`;
        console.error(msg, JSON.stringify(formatLog({
            error
        })));
        return null;
    }
};
/**
 * Request company suggestions.
 */ const fetchCompanySuggestions = async (inputValue, axiosOptions)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , apiBase  }  } = (0,next_config["default"])();
    const path = `${apiBase}/company-suggestion/${inputValue}`;
    try {
        const response = await axios_default()(path, {
            ...axiosOptions,
            ...{
                timeout: apiRequestTimeoutMs
            }
        });
        return response.data;
    } catch (error) {
        const msg = `Error requesting company suggestions from ${path}`;
        const err = JSON.stringify((0,logging/* formatLog */.U)({
            error
        }));
        console.error(msg, err);
        return null;
    }
};
/**
 * Request company suggestions from the service API.
 */ const fetchApiCompanySuggestions = async (query)=>{
    const { serverRuntimeConfig: { apiRequestTimeoutMs , jobsApiHost  }  } = getConfig();
    // if query exists we will pass it in the params.
    const queryObj = query ? {
        query
    } : {};
    const config = {
        params: {
            type: "company_name",
            ...queryObj
        },
        timeout: apiRequestTimeoutMs
    };
    const path = `${jobsApiHost}/api/v2/suggestions`;
    try {
        const response = await axios(path, config);
        return response.data;
    } catch (error) {
        const msg = `Error requesting jobs from ${path}`;
        const err = JSON.stringify(formatLog({
            error
        }));
        console.error(msg, err);
        return null;
    }
};
const getCulturesList = async (queryParams)=>{
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs  } , serverRuntimeConfig: { companyApiHost , companyApiToken , mockApiResponses  }  } = getConfig();
    const { companyShortName  } = queryParams;
    const cacheKey = `cultures_${companyShortName}`;
    const config = {
        timeout: apiRequestTimeoutMs,
        headers: {
            Authorization: `Bearer ${companyApiToken}`
        }
    };
    // If either query param length exceeds the maximum, throw a malformed request error
    if (companyShortName?.length > jobQueryCompanyShortnameMaxlength) {
        // eslint-disable-next-line max-len
        const msg = `Malformed Request: The companyShortName parameter exceeds maximum length of ${jobQueryCompanyShortnameMaxlength}.`;
        throw new Error(msg);
    }
    const path = isBrowser() ? `${apiBase}/company/${companyShortName}/culture/list` : `${companyApiHost}/api/v1/companies/${companyShortName}/culture/list`;
    // Check for the cultures in cache.
    const cachedCultures = apiCache.get(cacheKey);
    if (cachedCultures === undefined) {
        // Fetch the cultures from the API.
        const response = mockApiResponses ? {
            data: mockSingleCompany
        } : await axiosClient.get(path, config).catch((error)=>{
            const msg = `Error requesting company at ${path}.`;
            const err = JSON.stringify(formatLog({
                error
            }));
            console.error(msg, err);
        });
        // eslint-disable-next-line camelcase
        const cultures = response?.data?.data?.filter(({ is_active  })=>!!is_active);
        apiCache.set(cacheKey, cultures);
        console.info(`Cache refreshed, ${companyShortName} cultures retrieved from API.`);
        return cultures;
    }
    console.info(`Cache existing, ${companyShortName} cultures retrieved from NodeCache.`);
    return cachedCultures;
};
const getEmployeeStories = async (queryParams)=>{
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs  } , serverRuntimeConfig: { companyApiHost , companyApiToken , mockApiResponses  }  } = getConfig();
    const { companyShortName , culture  } = queryParams;
    const cacheKey = `employeeStories_${companyShortName}_${culture}`;
    const config = {
        timeout: apiRequestTimeoutMs,
        headers: {
            Authorization: `Bearer ${companyApiToken}`
        }
    };
    // If either query param length exceeds the maximum, throw a malformed request error
    if ([
        companyShortName,
        culture
    ].some((s)=>s?.length > jobQueryCompanyShortnameMaxlength)) {
        // eslint-disable-next-line max-len
        const msg = `Malformed Request: A request parameter exceeds maximum length of ${jobQueryCompanyShortnameMaxlength}.`;
        throw new Error(msg);
    }
    const cultureDirectory = culture === "all" ? "" : `/culture/${culture}`;
    const path = isBrowser() ? `${apiBase}/company/${companyShortName}/${culture}/employee_story/list` : `${companyApiHost}/api/v1/companies/${companyShortName}${cultureDirectory}/employee_story/list`;
    // Check for the cultures in cache.
    const cachedResponse = apiCache.get(cacheKey);
    if (cachedResponse === undefined) {
        // Fetch the cultures from the API.
        const response = mockApiResponses ? {
            data: mockSingleCompany
        } : await axiosClient.get(path, config).catch((error)=>{
            const msg = `Error requesting employee stories at ${path}.`;
            const err = JSON.stringify(formatLog({
                error
            }));
            console.error(msg, err);
        });
        // eslint-disable-next-line camelcase
        const employeeStories = response?.data?.data?.filter(({ is_active  })=>!!is_active);
        apiCache.set(cacheKey, employeeStories);
        // eslint-disable-next-line max-len
        console.info(`Cache refreshed, ${companyShortName} employee stories for ${culture} culture retrieved from API.`);
        return employeeStories;
    }
    // eslint-disable-next-line max-len
    console.info(`Cache existing, ${companyShortName} employee stories for ${culture} culture retrieved from NodeCache.`);
    return cachedResponse;
};


/***/ }),

/***/ 6704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ axiosClient; }
/* harmony export */ });
/* harmony import */ var http__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2321);
/* harmony import */ var http__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(http__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var https__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8428);
/* harmony import */ var https__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(https__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);



const httpAgentConfig = {
    keepAlive: true,
    timeout: 5000,
    maxSockets: Infinity
};
const axiosClient = axios__WEBPACK_IMPORTED_MODULE_2___default().create({
    timeout: 5000,
    httpAgent: new (http__WEBPACK_IMPORTED_MODULE_0___default().Agent)(httpAgentConfig),
    httpsAgent: new (https__WEBPACK_IMPORTED_MODULE_1___default().Agent)(httpAgentConfig),
    maxRedirects: 10,
    maxContentLength: 50 * 1000 * 1000
});


/***/ }),

/***/ 7228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jU": function() { return /* binding */ isBrowser; }
/* harmony export */ });
/* unused harmony exports isMobile, parseQueryParamsToObject, getUserLatLng, shouldShowFeature, toggleWindowFreeze, getOptimizeData */
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);

/**
 * Are we currently within a browser.
 */ const isBrowser = ()=> true && typeof window.document !== "undefined";
/**
 * Is the browser currently set to 768px or less wide.
 * Expects window.innerWidth;
 */ const isMobile = ()=>isBrowser() && window.innerWidth <= 768;
// https://stackoverflow.com/a/8649003
/**
 * Parses a query param string and returns an object of the values
 * @param query - valid string to parse
 */ const parseQueryParamsToObject = (query = "")=>{
    let queryString = query;
    if (queryString && queryString[0] === "?") {
        queryString = queryString.substring(1);
    }
    try {
        return JSON.parse(`{"${decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`);
    } catch  {
        return null;
    }
};
/**
 * Returns the user's lat,lng from session storage in an array.
 */ const getUserLatLng = ()=>{
    if (!isBrowser()) {
        return [
            null,
            null
        ];
    }
    const lat = parseFloat(window.sessionStorage.getItem("carmen_lat"));
    const lng = parseFloat(window.sessionStorage.getItem("carmen_lon"));
    return [
        lat,
        lng
    ];
};
/**
 * Take a name and determine if the feature should show or be hidden
 * based on environment variable.
 */ const shouldShowFeature = (name)=>{
    const { publicRuntimeConfig  } = getConfig();
    const FEATURE_FLAGS = {
        example: "featureFlagExample"
    };
    if (FEATURE_FLAGS[name] && typeof publicRuntimeConfig[FEATURE_FLAGS[name]] !== "undefined") {
        return !(publicRuntimeConfig[FEATURE_FLAGS[name]] === "false");
    }
    return true;
};
const toggleWindowFreeze = ()=>{
    const { body: { style  }  } = document;
    if (style.overflow === "hidden") {
        style.height = "auto";
        style.overflow = "auto";
    } else {
        style.height = "100vh";
        style.overflow = "hidden";
    }
};
/**
 * Extracts Optimize experiment id and variant id from data layer
 *
 */ const getOptimizeData = ()=>{
    const allExperiments = [];
    if (isBrowser() && "dataLayer" in window) {
        const experiments = window.dataLayer.filter((x)=>typeof x === "object" && "experimentID" in x);
        if (experiments.length > 0) {
            experiments.forEach((x)=>{
                allExperiments.push({
                    experiment_id: x.experimentID,
                    variant_id: x.variantID
                });
            });
        }
    }
    return allExperiments;
};


/***/ }),

/***/ 3135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L8": function() { return /* binding */ jobSearchQueryMaxlength; },
/* harmony export */   "dn": function() { return /* binding */ contentTabIds; }
/* harmony export */ });
/* unused harmony exports jobQueryCompanyShortnameMaxlength, jobQueryJobShortnameMaxlength, months, suggestionApiQueryMaxlength */
// Months array for date formatting
const months = (/* unused pure expression or super */ null && ([
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
]));
// Character limit for suggestion api
const suggestionApiQueryMaxlength = 70;
// Character limit for job search api
const jobQueryCompanyShortnameMaxlength = 50;
const jobQueryJobShortnameMaxlength = 250;
const jobSearchQueryMaxlength = 40;
const contentTabIds = {
    main: {
        panel: "company-panel--main",
        tab: "company-tab--main"
    },
    articles: {
        panel: "company-panel--articles",
        tab: "company-tab--articles"
    },
    team: {
        panel: "company-panel--team",
        tab: "company-tab--team"
    }
};



/***/ }),

/***/ 4453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ formatLog; }
/* harmony export */ });
/* unused harmony export axiosErrorToLogMap */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

const axiosErrorToLogMap = {
    http: {
        url: "config.url",
        status_code: "response.status",
        method: "request.method"
    }
};
const LOG_STATUS = {
    INFO: "info",
    WARN: "warn",
    ERROR: "error"
};
/**
 * Formats the message key for the log e.g. HTTP GET /foo/bar
 * @example
 * const message = formatMessage("GET", "foo/bar");
 * console.log(message);
 */ const formatMessage = (method, url)=>`HTTP ${method} ${url}`;
/**
 * Returns the log level string based on the status code
 * @example
 * const logLevel = getLogLevel(500);
 * console.log(logLevel);
 */ const getLogLevel = (statusCode = 200, defaultLevel = LOG_STATUS.INFO)=>{
    switch(Math.floor(statusCode / 100)){
        case 5:
            return LOG_STATUS.ERROR;
        case 4:
            return LOG_STATUS.WARN;
        default:
            return defaultLevel;
    }
};
/**
 * Gets a nested value from on object via a string reference
 * @example
 * const nestedObject = { foo: { bar: 7 } };
 * const nestedValue = getNested(nestedObject, "foo.bar");
 * console.log(nestedValue);
 */ const getNested = (theObject, path, separator = ".")=>{
    try {
        return path.replace("[", separator).replace("]", "").split(separator).reduce((obj, property)=>obj[property], theObject);
    } catch (err) {
        return undefined;
    }
};
/**
 * Creates a new object using the values in mappedObject and the
 * key references in the map. Essentially an object reducer.
 * @example
 * const mappableObject = { foo: { bar: 7 } };
 * const map = { baz: "foo.bar" };
 * const mappedObject = mappedObject(mappableObject, map);
 * console.log(mappedObject);
 */ const mapObj = (mappedObject, map)=>{
    const newObject = {};
    // Traverse the object
    Object.keys(map).forEach((key)=>{
        let newObjectValue;
        if (typeof map[key] === "object") {
            newObjectValue = mapObj(mappedObject, map[key]);
        } else {
            newObjectValue = getNested({
                ...mappedObject
            }, map[key]);
        }
        newObject[key] = newObjectValue;
    });
    return newObject;
};
/**
 * Uses values from a Koa context object and an optional error object
 * to create a formatted log object. Uses mapObj to translate to the
 * desired format. Takes an optional mapping argument to override the default.
 * @example
 * const formattedLog = formatLog(context, error);
 * console.log(formattedLog);
 */ const formatLog = (format)=>{
    const { context , error , contextToLogMap =axiosErrorToLogMap  } = format;
    let contextValues = null;
    let logInfo = null;
    if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error)) {
        contextValues = mapObj({
            ...error
        }, {
            ...contextToLogMap
        });
        logInfo = {
            ...contextValues,
            level: getLogLevel(contextValues?.http?.status_code || error.status),
            message: formatMessage(contextValues.http.method || error.message, contextValues.http.url)
        };
    } else {
        const { req: { method ="" , url =""  } = {} , res: { statusCode =0  } = {}  } = context || {};
        contextValues = mapObj({
            ...context
        }, {
            ...contextToLogMap
        });
        logInfo = {
            ...contextValues,
            level: getLogLevel(statusCode),
            message: formatMessage(method, url)
        };
    }
    const errorValues = error ? {
        message: error.message,
        stack: error.stack,
        kind: error.name
    } : null;
    return {
        ...logInfo,
        ...errorValues && {
            error: errorValues
        }
    };
};


/***/ })

}]);